export const SOURCES_INDEX__SET_ALL = 'SOURCES_INDEX__SET_ALL';
export const SOURCES_INDEX__ADD_RESOURCE = 'SOURCES_INDEX__ADD_RESOURCE';
export const SOURCES_INDEX__UPDATE_RESOURCE = 'SOURCES_INDEX__UPDATE_RESOURCE';
export const SOURCES_INDEX__REMOVE_RESOURCE = 'SOURCES_INDEX__REMOVE_RESOURCE';
export const SOURCES_INDEX__CLEAR_ALL = 'SOURCES_INDEX__CLEAR_ALL';
